import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { MdClose } from 'react-icons/md';
import Text from '../../../styled/Text';
import { colors } from '../../../../constants';

const StyledColoredTag = styled.div`
  background: ${props => props.color};
  display: flex;
  gap: 8px;
  height: 28px;
  border: none;
  border-radius: 76px;
  padding: 2px 8px;
  justify-content: space-between;
  align-items: center;
`;

const StyledCloseButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 21px;
  height: 21px;
  border-radius: 10px;
  background-color: ${props => props.color};
  filter: brightness(0.9);
  cursor: pointer;
  svg {
    width: 18px;
    height: 18px;
  }
`;

const ColorTag = ({ color, label, onClick, labelColor }) => {
  return (
    <StyledColoredTag color={color}>
      <Text variant="body-small" color={labelColor}>
        {label}
      </Text>
      {onClick && (
        <StyledCloseButton color={color} onClick={onClick}>
          <MdClose fill={labelColor} />
        </StyledCloseButton>
      )}
    </StyledColoredTag>
  );
};

ColorTag.propTypes = {
  label: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  labelColor: PropTypes.string,
  onClick: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
};

ColorTag.defaultProps = {
  labelColor: colors.white,
};

export default ColorTag;
